

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function Tooltip({ text, children, position = "right" }) {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState(null);

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setCoords(rect);
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  const getStyle = () => {
    if (!coords) return {};

    switch (position) {
      case "left":
        return {
          top: coords.top + coords.height / 2,
          left: coords.left - 8,
          transform: "translate(-100%, -50%)",
        };
      case "top":
        return {
          top: coords.top - 8,
          left: coords.left + coords.width / 2,
          transform: "translate(-50%, -100%)",
        };
      case "bottom":
        return {
          top: coords.bottom + 8,
          left: coords.left + coords.width / 2,
          transform: "translate(-50%, 0)",
        };
      case "right":
      default:
        return {
          top: coords.top + coords.height / 2,
          left: coords.right + 8,
          transform: "translate(0, -50%)",
        };
    }
  };

  return (
    <>
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="d-inline-flex"
      >
        {children}
      </div>

      {show &&
        coords &&
        createPortal(
          <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
            style={{
              position: "fixed", // 🔥 CLAVE
              zIndex: 9999999,
              whiteSpace: "nowrap",
              fontSize: "1rem",
              background: "#111",
              color: "#fff",
              padding: "6px 10px",
              borderRadius: "6px",
              pointerEvents: "none",
              ...getStyle(),
            }}
          >
            {text}
          </motion.div>,
          document.body
        )}
    </>
  );
}